import { Droplets, WrenchIcon, ThermometerSun, Factory, HeartPulse, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: <Droplets className="h-8 w-8" />,
    title: 'Pool Maintenance',
    description: `Keeping your pool in perfect condition year-round requires expert care. Our routine maintenance services include:

Water testing & chemical balancing to keep the pool safe and clean
Filter & pump inspections to ensure optimal performance
Debris removal & vacuuming for crystal-clear water
Algae treatment & prevention`,
    slug: 'pool maintenance',
    image: '/Pool Maintenance.png'
  },
  {
    icon: <WrenchIcon className="h-8 w-8" />,
    title: 'Repairs & Equipment',
    description: `Is your pool equipment not working properly? We provide fast and efficient repairs for:

Pumps, filters, and skimmers
Pool leaks and plumbing issues
Lights and electrical components

We diagnose and fix problems quickly, so you can enjoy your pool without worries.`,
    slug: 'repairs-equipment',
    image: '/Repairs & Equipment.png'
  },
  {
    icon: <ThermometerSun className="h-8 w-8" />,
    title: 'Heat Pumps',
    description: 'Energy efficient pool heating solutions for year round swimming.',
    slug: 'heat-pumps',
    image: '/Heat Pumps.png'
  },
  {
    icon: <Factory className="h-8 w-8" />,
    title: 'New Pool Installation',
    description: `We specialize in complete pool installation, ensuring a fully functional and high quality setup. Whether it's a residential or commercial pool, our team handles:

Structural work & waterproofing
Piping & filtration systems
Pump, skimmer, and drainage installation
Lighting, heating, and automation setup

We do not provide pool design but work closely with builders and architects to install everything your pool needs to function perfectly.

Get in touch today for a consultation!`,
    slug: 'new-pool-installation',
    image: '/New Pool Installation.png'
  },
  {
    icon: <HeartPulse className="h-8 w-8" />,
    title: 'Water Care',
    description: `Balanced water = a healthy pool. We offer:

Professional water testing & analysis
Chemical treatment for safety & hygiene
Algae removal & prevention
Saltwater system maintenance

Say goodbye to murky, unsafe water—we keep it crystal clear!`,
    slug: 'water-care',
    image: '/Water Care.png'
  }
];

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          From new construction projects to year round pool care, we deliver complete technical solutions
           including piping, filtration, heating systems and maintenance for developers, contractors, and private homes.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link
              to={`/services/${service.slug}`}
              key={index}
              className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col hover:-translate-y-1"
            >
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden">
                {service.image && (
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Service Content */}
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center mb-4">
                  <div className="bg-cyan-50 rounded-full p-3 group-hover:bg-cyan-100 transition-colors">
                    <div className="text-cyan-600 group-hover:text-cyan-700 transition-colors">
                      {service.icon}
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 ml-3">
                    {service.title}
                  </h3>
                </div>
                <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                  {service.description}
                </p>
                <div className="mt-auto flex items-center text-cyan-600 text-sm font-medium group-hover:text-cyan-700">
                  Learn More
                  <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;